var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.77375 0C0.794438 0 0 0.77025 0 1.71919V22.2814C0 23.2304 0.794531 24 1.77375 24H22.2262C23.2059 24 24 23.2303 24 22.2811V1.71919C24 0.77025 23.2059 0 22.2262 0H1.77375ZM7.2933 9.2801V20.085H3.70192V9.2801H7.2933ZM7.53002 5.93856C7.53002 6.97544 6.75048 7.80513 5.49836 7.80513L5.49808 7.80503H5.47483C4.26948 7.80503 3.49023 6.97535 3.49023 5.93847C3.49023 4.87806 4.29302 4.07153 5.52217 4.07153C6.75048 4.07153 7.50658 4.87806 7.53002 5.93856ZM12.8723 20.085H9.28117L9.28108 20.0853C9.28108 20.0853 9.32823 10.2941 9.28136 9.28047H12.8725V10.8099C13.3499 10.0738 14.2043 9.02678 16.1093 9.02678C18.472 9.02678 20.2435 10.5711 20.2435 13.8898V20.085H16.6525V14.3053C16.6525 12.8526 16.1325 11.8619 14.8333 11.8619C13.841 11.8619 13.2501 12.53 12.9906 13.1755C12.8957 13.4058 12.8723 13.7292 12.8723 14.0517V20.085Z",
    fill: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedinLogo.0b97cb94296ac582062fae9c115bbc6f.svg";
export { ForwardRef as ReactComponent };